import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f89aa390")

_pushScopeId("data-v-f89aa390")
const _hoisted_1 = {
  key: 0,
  class: "bg-gray-900 bg-opacity-60 fixed top-0 bottom-0 inset-0 z-20"
}
const _hoisted_2 = { class: "\n        relative\n          overflow-y-auto overflow-x-hidden\n          h-full\n          w-full\n          px-4\n          pb-4\n          pt-6\n          min-h-0\n        " }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_fa_icon = _resolveComponent("fa-icon")

  return (_openBlock(), _createBlock(_Transition, {
    name: "fade",
    appear: ""
  }, {
    default: _withId(() => [
      (_ctx.modalState)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode(_Transition, {
              name: "delayed-slide",
              appear: ""
            }, {
              default: _withId(() => [
                (_ctx.innerModal)
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      class: "\n        modal-white-container\n        bg-white\n        fixed\n        md:top-1/2\n        md:left-1/2\n        transform\n        md:-translate-x-1/2\n        md:-translate-y-1/2\n        md:rounded-md\n        overflow-hidden\n        shadow-lg\n        flex\n        flex-col\n        top-20\n        left-0\n        right-0\n        modal-w\n      ",
                      style: { width: _ctx.width, minHeight: _ctx.large ? '610px': 'auto' }
                    }, [
                      _createVNode("div", {
                        class: "\n          absolute\n          shadow-md\n          top-1.5\n          right-1.5\n          z-20\n          rounded-lg\n          h-7\n          w-7\n          flex\n          justify-center\n          items-center\n          text-gray-400\n          cursor-pointer\n          border\n          bg-white\n          border-gray-100\n        ",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.innerModalDismiss && _ctx.innerModalDismiss(...args)))
                      }, [
                        _createVNode(_component_fa_icon, { icon: ['fa', 'times'] })
                      ]),
                      _createVNode("div", _hoisted_2, [
                        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                      ])
                    ], 4))
                  : _createCommentVNode("", true)
              ]),
              _: 3
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})